import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// ⚠️  Replace with your actual Firebase project config
// (same project as your admin app — same Firestore database)
const firebaseConfig = {
  apiKey: "AIzaSyCAETowEf8xw6GDw-Ztc2WTu_L_SNvj1AA",
  authDomain: "atlasroutelogistics-6497b.firebaseapp.com",
  databaseURL: "https://atlasroutelogistics-6497b-default-rtdb.firebaseio.com",
  projectId: "atlasroutelogistics-6497b",
  storageBucket: "atlasroutelogistics-6497b.firebasestorage.app",
  messagingSenderId: "328431983145",
  appId: "1:328431983145:web:5bf35343c1375c3a1f9a38"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export default app;

// ── Cloudinary config ──────────────────────────────────────────
// Replace these with your actual Cloudinary credentials
export const CLOUDINARY_CLOUD_NAME = "dzryuu3ux";
export const CLOUDINARY_UPLOAD_PRESET = "uhjewduiuiygew"; // unsigned preset